import { gql } from '@apollo/client'

import { SHOP_CART_ITEM_MODIFIER_FRAGMENT } from './cartItemModifier'
import { SHOP_RECIPIENT_FRAGMENT } from './recipient'

export const SHOP_CART_ITEM_FRAGMENT = gql`
  fragment ShopCartItem on ShopCartItem {
    categoryName
    coverSerializableHash
    coverThumbUrl
    customerNote
    id
    menuId
    menuItemId
    cartItemModifiers {
      ...ShopCartItemModifier
    }
    name
    piecePrice
    quantity
    recipient {
      ...ShopRecipient
    }
    totalPrice
    totalPriceFormatted
    type
    variantName
  }
  ${SHOP_CART_ITEM_MODIFIER_FRAGMENT}
  ${SHOP_RECIPIENT_FRAGMENT}
`
